module.exports = __webpack_public_path__ + "img/light_ic_screen_led.59d6f816.png";